<template>
  <div>
    <v-tabs class="tabs" v-model="currentItem" left slider-color="white">
      <v-tab class="smaller-tab" key="hubs">
        HUB
      </v-tab>
      <v-tab class="smaller-tab" key="wardens">
        Warden
      </v-tab>
      <v-tab class="smaller-tab" key="anpr"> ANPR </v-tab>
      <v-col class="button-panel">
        <v-row>
          <v-spacer />
          <v-btn
          v-if="currentItem === 0 && auth.isParkmanAdmin() && hubsList.length === 0"
            class="pkmn-button-small"
            color="primary"
            @click="addHub"
          >
            Add HUB
          </v-btn>
          <v-btn
          v-if="currentItem === 2 && auth.isParkmanAdmin() && cameraConnection === null"
            class="pkmn-button-small"
            color="primary"
            @click="showAddANPRPopup"
          >
            Add ANPR Connection
          </v-btn>
        </v-row>
      </v-col>
    </v-tabs>

    <v-tabs-items class="tab-integrations-items" v-model="currentItem">
      <v-tab-item class="tab-item" key="hubs">
        <v-divider class="mb-4" />
        <subtab-hubs
        v-if="hubsList.length > 0" 
        :hubsList="hubsList" 
        @delete="deleteHub"
        />
        <p v-else class="form-dialog__subtitle">
          There is no HUB connection set up yet.
        </p>
      </v-tab-item>
      <v-tab-item class="tab-item" key="wardens">
        <v-divider class="mb-4" />
        <subtab-warden
         :wardensList="wardensList"
         @add="addWarden" 
         @delete="deleteWarden"/>
      </v-tab-item>
      <v-tab-item class="tab-item" key="anpr">
        <v-divider class="mb-4" />
        <subtab-camera
        :connections="[cameraConnection]"
        :anprConfig="anprConfig"
        @deleteAnpr="deleteAnpr"
        v-if="cameraConnection !== null"
        />
        <p v-else class="form-dialog__subtitle">
          There is no ANPR connected yet.
        </p>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import SubtabHubs from '@/components/Locations/AddVisitorParking/Subtabs/SubtabHubs.vue'
import SubtabWarden from '@/components/Locations/AddVisitorParking/Subtabs/SubtabWarden.vue'
import SubtabCamera from '../Subtabs/SubtabCamera.vue'
import auth from '@/auth'

export default {
  name: 'TabIntegrations',
  components: { SubtabHubs, SubtabWarden, SubtabCamera },
  props: {
    hubsList: {
      type: Array,
      default: () => []
    },
    wardensList: {
      type: Array,
      default: () => []
    },
    cameraConnection: {
      type: Object,
      default: null
    },
    anprConfig: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    auth: auth,
    currentItem: 0
  }),
  methods: {
    addWarden(warden) {
      this.$emit('add', warden)
    },
    deleteWarden(warden) {
      this.$emit('delete', warden)
    },
    addHub() {
      this.$emit('addHub')
    },
    deleteHub() {
      this.$emit('deleteHub')
    },
    showAddANPRPopup() {
      this.$emit('addANPR')
    },
    deleteAnpr() {
      this.$emit('deleteAnpr')
    }
  },
  mounted() {
    this.currentItem = 0
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/common';
@import '~@/style/variables';

.tabs {
  margin-left: 0;
  margin-top: 0;
  max-height: 32px;
}

.button-panel {
  padding: 4px 14px 40px;
}
</style>
